<template>
  <div>
    <!-- Trabajadores ImagenNombre -->
    <f7-block class="padding-top-half">
      <f7-row>
        <f7-col>
          <div class="content-workers-list">
            <div
              v-for="d in workerElementProduction"
              :key="d.Id"
              no-gap
              class="content-workers-list__worker padding-bottom-half"
            >
              <div>
                <img
                  v-if="d.Trabajador.Sujeto.ImagenPerfil == null"
                  src="@/static/icons/ic_user.svg"
                  class="avatar-round"
                >
                <img
                  v-if="d.Trabajador.Sujeto.ImagenPerfil != null"
                  :src="d.Trabajador.Sujeto.ImagenPerfil.Archivo"
                  class="avatar-round"
                >
              </div>
              <div>
                <div class="content-workers-list__worker--title">
                  {{ d.Trabajador.Sujeto.NombreCompleto }}
                </div>
                <div class="content-workers-list__worker--subtitle">
                  {{ d.ActividadProduccion.Nombre }}
                </div>
              </div>
            </div>
          </div>
        </f7-col>
        <f7-col>
          <UCSearchEntityERP
            :title="$t('searchEntity.line.title.selectDestinationLine')"
            :placeholder="$t('searchEntity.line.placeholder.codeLine')"
            :search-text="$t('searchEntity.line.searchText')"
            :search-cancellation-text="$t('searchEntity.line.searchCancellationText')"
            :search-not-found-text="$t('searchEntity.line.searchNotFoundText')"
            :end-point-for-code-search="ProductionLineCodeSearch"
            :end-point-for-list="ProductionLineList"
            :property-entity-shown-input="['Codigo', 'Nombre']"
            :property-entity-shown-list-title="['Codigo']"
            :property-entity-shown-list-subtitle="['Nombre']"
            :next-and-previous-buttons-shown="false"
            @selection="EventSelectedProductionLine"
          />
          <UCSearchEntityERP
            ref="UCSearchActivity"
            class="margin-top"
            :title="$t('searchEntity.productionActivity.title.chooseTargetProductionActivity')"
            :placeholder="$t('searchEntity.productionActivity.placeholder.productionActivityCode')"
            :search-text="$t('searchEntity.productionActivity.searchText')"
            :search-cancellation-text="$t('searchEntity.productionActivity.searchCancellationText')"
            :search-not-found-text="$t('searchEntity.productionActivity.searchNotFoundText')"
            :end-point-for-code-search="ActivityCodeSearch"
            :end-point-for-list="ActivityList"
            :property-entity-shown-input="['Codigo', 'Nombre']"
            :property-entity-shown-list-title="['Codigo']"
            :property-entity-shown-list-subtitle="['Nombre']"
            :disabled="selectedProductionLine == null"
            @selection="EventSelectedProductionActivity"
          />
          <UCDatePicker
            id="date-picker-pcChangeWorkersProductionLine"
            title="Fecha de marcaje"
            :min-date="GetMinDateRecord()"
            :max-date="GetMaxDateRecord()"
            @onchange="DateChanged"
          />
          <UCTimePicker
            id="time-picker-pcChangeWorkersProductionLine"
            :show-input="false"
            :template="templateForTimePicker"
            :title="templateForTimePicker === 'P2' ? 'Hora Marcaje' : ''"
            :show-seconds="secondsOnTimePicker"
            @onchange="TimeChanged"
          />
          <f7-button
            fill
            color="greendark"
            class="margin-top"
            @click="ChangeProductionLineWorkers()"
          >
            CAMBIAR TRABAJADORES
          </f7-button>
        </f7-col>
      </f7-row>
    </f7-block>
  </div>
</template>

<script>
import {
  Log,
  LogError,
} from '@/js/common/HIDebuggingSupport';
import UCSearchEntityERP from '@/components/common/UCSearchEntityERP.vue';
import APIErp from '@/js/services/APIErp';
import { HiDateTimeSupport } from '@/js/common/HIConversionSupport';
import {
  HiDialog,
  HiNotification,
} from '@/js/common/HINotificationSupport';
import UCDatePicker from '@/components/common/UCDatePicker.vue';
import UCTimePicker from '@/components/common/UCTimePicker.vue';

/** @import { MarcajeCerco } from '@erpagroapp/types' */

export default {
  name: 'PCChangeWorkersProductionLine',
  components: {
    UCSearchEntityERP,
    UCTimePicker,
    UCDatePicker,
  },
  props: {
    workerElementProduction: { type: Array, default: null },
    restrictDayMarking: { type: Boolean, default: false },
    secondsOnTimePicker: { type: Boolean, default: false },
    templateForTimePicker: { type: String, default: 'P1' },
  },

  emits: [
    'action-completed',
    'on-success',
    'on-error',
  ],

  data() {
    return {
      selectedActivityNewRecords: null,
      selectedProductionLine: null,
      dateTimeNewRecord: Date.now(),
      dateNewRecord: Date.now(),
      timeNewRecord: '00:00',
    };
  },

  methods: {
    ChangeProductionLineWorkers() {
      Log(this, this.ChangeProductionLineWorkers.name);
      if (this.workerElementProduction == null || this.workerElementProduction.length === 0) {
        HiNotification.Toast('Es necesario seleccionar al menos a un trabajador', 4000);
        return;
      }
      if (this.selectedActivityNewRecords == null) {
        HiNotification.Toast('Es necesario seleccionar una actividad de producción para la nueva línea', 6000);
        return;
      }

      // this.dateTimeNewRecord = new Date();
      const listObjMarcaje = [];
      let hasErrors = false;

      for (const item of this.workerElementProduction) {
        if (item.checked) {
          const fechaHora = HiDateTimeSupport.FormatDateTime(this.dateTimeNewRecord, '');

          if (fechaHora <= item.FechaInicio) {
            this.$emit('on-error', { item, textError: 'El cambio de línea tiene una fecha inferior' });
            hasErrors = true;
          } else {
            // GESTIÓN  DE ACTIVIDADES DE MARCAJE DOBLE (Generar marcaje de fin actividad)
            if (item.ActividadProduccion.ModoMarcaje === 1) {
              /** @type {PartialDeep<MarcajeCerco>} */
              const objMarcajeFin = {
                Id: 0,
                Trabajador: item.Trabajador,
                ActividadProduccion: item.ActividadProduccion,
                LineaProduccion: item.LineaProduccion,
                FechaHora: HiDateTimeSupport.FormatDateTime(HiDateTimeSupport.AddSeconds(this.dateTimeNewRecord, -1)),
              };
              listObjMarcaje.push(objMarcajeFin);
            }

            /** @type {PartialDeep<MarcajeCerco>} */
            const objMarcaje = {
              Id: 0,
              Trabajador: item.Trabajador,
              ActividadProduccion: this.selectedActivityNewRecords,
              LineaProduccion: this.selectedProductionLine,
              FechaHora: fechaHora,
            };
            listObjMarcaje.push(objMarcaje);
          }
        }
      }

      if (hasErrors) {
        return;
      }

      const self = this;
      HiDialog.Preloader(true, 'Cambiando trabajadores linea');
      this.Conections_MakeNewRecordWorker(listObjMarcaje).then(() => {
        HiNotification.Toast('Trabajadores cambiados correctamente', 6000);
        self.$emit('action-completed');
      }).catch(() => {
        HiNotification.Toast('Alguno de los trabajadores no han sido cambiados de linea.', 14000);
      }).finally(() => {
        HiDialog.Preloader(false);
        this.$emit('on-success');
      });
    },
    /*
    EventSelectedProductionLine(objProductionLine) {
      Log(this, this.EventSelectedProductionLine.name);
      this.selectedProductionLine = objProductionLine;
      if (this.selectedProductionLine === null) {
        this.$refs.UCSearchActivity.Clear();
      }
      // this.GetMainData();
    },
    */
    async EventSelectedProductionLine(objLine) {
      Log(this, this.EventSelectedProductionLine.name);
      this.selectedProductionLine = objLine;
      if (this.selectedProductionLine != null) {
        HiDialog.Preloader(true);
        const result = await this.ActivityList();
        if (result != null && result.status === 200 && result.data.length === 1) {
          this.$refs.UCSearchActivity.SelectEntity(result.data[0], true);
          // [this.selectedActivity] = result.data;
        }
        HiDialog.Preloader(false);
      } else {
        this.$refs.UCSearchActivity.Clear();
      }
    },
    /*
    async EventSelectedProductionActivity(objActivity) {
      Log(this, this.EventSelectedProductionActivity.name);
      this.selectedActivity = objActivity;
      if (this.selectedActivity != null) {
        this.$refs.UCSearchProductionLine.Clear();
        HiDialog.Preloader(true);
        const result = await this.ProductionLineList();
        if (result != null && result.status === 200 && result.data.length === 1) {
          this.$refs.UCSearchProductionLine.SelectEntity(result.data[0], false);
          [this.selectedProductionLine] = result.data;
        }
        HiDialog.Preloader(false);
      }
    },
    */
    EventSelectedProductionActivity(objActivity) {
      Log(this, this.EventSelectedProductionActivity.name);
      this.selectedActivityNewRecords = objActivity;
    },
    /* ****************** CONNECTIONS  ********************* ** */
    /* ********************************************************* */
    ActivityCodeSearch(params) {
      Log(this, this.ActivityCodeSearch.name);
      return APIErp.callProductionActivitySearchCode(params);
    },
    ActivityList() {
      Log(this, this.ActivityList.name);
      if (this.selectedProductionLine != null) {
        return APIErp.callProductionActivityListXLineAuthorized(this.selectedProductionLine.Id);
      }
      return APIErp.callProductionActivityListAuthorized();
    },
    ProductionLineCodeSearch(params) {
      Log(this, this.ProductionLineCodeSearch.name);
      return APIErp.callProductionLineSearchCode(params);
    },
    ProductionLineList() {
      Log(this, this.ProductionLineList.name);
      if (this.selectedActivity != null) {
        return APIErp.callLinesListXActivity(this.selectedActivity.Id);
      }
      return APIErp.callProductionLineListAuthorized();
    },
    Conections_MakeNewRecordWorker(listObjMarcaje) {
      Log(this, this.Conections_MakeNewRecordWorker.name);
      return new Promise((resolve, reject) => {
        APIErp.callMakeNewRecordsWorkers(listObjMarcaje)
          .then((result) => {
            if (result.data.valor) {
              resolve();
            } else {
              reject(result.data.tag); // Alguno de los marcajes no se ha realizado correctamente.
            }
          }).catch((error) => {
            LogError(this, this.Conections_MakeNewRecordWorker.name, error);
          });
      });
    },
    TimeChanged(value) {
      Log(this, this.TimeChanged.name);
      this.timeNewRecord = value;
      this.dateTimeNewRecord = `${HiDateTimeSupport.FormatDateTime(this.dateNewRecord, 'YYYY-MM-DD')} ${value}`;
    },
    DateChanged(value) {
      Log(this, this.DateChanged.name);
      this.dateNewRecord = `${HiDateTimeSupport.FormatDateTime(value, 'YYYY-MM-DD')}`;
      this.dateTimeNewRecord = `${this.dateNewRecord}  ${this.timeNewRecord}`;
    },
    GetMaxDateRecord() {
      if (this.restrictDayMarking) {
        return HiDateTimeSupport.AddHoursAndMinutes(new Date(), 24, 0);
      }
      return new Date(8640000000000000);
    },
    GetMinDateRecord() {
      if (this.restrictDayMarking) {
        return HiDateTimeSupport.AddHoursAndMinutes(new Date(), -48, 0);
      }
      return new Date(-8640000000000000);
    },
  },
};
</script>

<style lang="scss">
.content-workers-list {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  height: calc(78vh);
  overflow-y: scroll;

  &__worker {
    display: flex;
    align-items: center;
    width: 100%;

    img {
      width: 48px;
      height: 48px;
      margin-right: 10px;
    }

    &--title {
      width: 100%;
      font-size: 16px;
      font-weight: 600;
      color: var(--his-steel-blue);
    }

    &--subtitle {
      font-size: 14px;
      color: var(--his-kiwi-pulp);
      font-weight: 500;
      text-transform: uppercase;
    }
  }
}
</style>
